import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "../../Layout/Header/Header";
import MenuList from "../../FilterComponent/MenuList/MenuList";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getProductDetailsAPI,
  getProductsByMetalId,
  getTopSellingProductsAPI,
} from "../../../../Store/Action/productAction";
import ProductCard from "../../CustomComponents/ProductCard";
import "./ProductListingPage.css";
import FilterOptions from "../../FilterComponent/FilterList/FilterOptions";
import {
  clearFilters,
  setProducts,
} from "../../../../Store/Slice/productSlice";
import { applyFilters } from "../../../../Store/Slice/filterSlice";
import CustomLoader from "../../CustomComponents/CustomLoader/CustomLoader";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";
import { cheerfulFiestaPaletteLight } from "@mui/x-charts";
import OrderWeightInfoPopup from "../../Auth/MyAccount/CustomModals/OrderWeightInfoPopup";
import Footer from "../../Layout/Footer/Footer";
import { getGlobalFilterAPI } from "../../../../Store/Action/globalFilterAction";
import { getCartTotalAPI } from "../../../../Store/Action/cartAction";
import { getProductPurityDetailsAPI } from "../../../../Store/Action/productPurityAction";
import { Helmet } from "react-helmet-async";

const ProductListsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { productId } = useParams();

  // const [headerHeight, setHeaderHeight] = useState(0);

  // useEffect(() => {
  //   const updateHeaderHeight = () => {
  //     const header = document.querySelector("mainContainer-navbar"); // Adjust this if your header has a different tag/class
  //
  //     if (header) {
  //       setHeaderHeight(header.offsetHeight);
  //     }
  //   };

  //   updateHeaderHeight(); // Set initial value
  //   window.addEventListener("resize", updateHeaderHeight); // Update on resize

  //   return () => window.removeEventListener("resize", updateHeaderHeight); // Cleanup
  // }, []);

  const [subCategory, setSubCategory] = useState(null);
  const [productMetalName, setProductMetalName] = useState(null);
  const [topSellingProducts, setTopSellingProducts] = useState([]);
  const [newArrival, setNewArrival] = useState([]);

  // const [isLoading, setIsLoading] = useState(false);
  const [isSubCategoryLoading, setIsSubCategoryLoading] = useState(false);
  const [isMetalLoading, setIsMetalLoading] = useState(false);
  const [isTopSellingLoading, setIsTopSellingLoading] = useState(false);
  const [isNewArrivalLoading, setIsNewArrivalLoading] = useState(false);

  const [metalProducts, setMetalProducts] = useState([]);

  const [subCategoryProducts, setSubCategoryProducts] = useState([]);

  const [productsLength, setProductsLength] = useState(null);

  const [caratOptions, setCaratOptions] = useState([]);

  useEffect(() => {
    dispatch(
      getProductPurityDetailsAPI({}, (result) => {
        if (result?.status && result?.data) {
          const purityOptions = result.data.map((purity) => ({
            id: purity.stamp_melting_id, // Assuming this is the ID field for purity
            name: purity.stamp_value, // Assuming this is the name/label field for purity
          }));
          setCaratOptions(purityOptions); // Set Carat options
        }
      }),
    );
  }, [dispatch]);
  // const [isWastageEnabled, SetIsWastageEnabled] = useState(true);
  const isWastageEnabled = useSelector(
    (state) => state.wastage.isWastageEnabled,
  );
  const cartChangeTrigger = useSelector(
    (state) => state.popupTrigger.cartChangeTrigger,
  );

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };
  useEffect(() => {
    dispatch(
      getCartTotalAPI({}, (result) => {
        if (result?.status && result?.data?.length > 0) {
          const cart = result.data[0];
          const hasItems =
            Object.values(cart.product_total).some(
              (item) => item.quantity > 0,
            ) ||
            Object.values(cart.per_pc_product_total).some(
              (item) => item.quantity > 0,
            );

          setIsPopupVisible(hasItems);
        }
      }),
    );
  }, [dispatch, cartChangeTrigger]);

  const [userRole, setUserRole] = useState("");
  const fromProductMetal = location?.state?.fromProductMetal;
  const fromTopSellingProduct = location?.state === "fromTopSellingProducts";
  const fromNewArrival = location?.state === "fromNewArrival";

  const subCategoryId = productId || location.state?.subCategoryId;
  const manufactureId = location.state?.manufacturerId;
  const subCategoryName = location.state?.subCategoryName;
  const metalId = location.state?.metalId;
  const metalName = location.state?.metalName;

  const [loading, setLoading] = useState(false);
  const observer = useRef(null);
  const [page, setPage] = useState(1);
  const [hasMoreProducts, setHasMoreProducts] = useState(true); // Track if more products are available
  // const [totalProducts, setTotalProducts] = useState(0); // Track total products available

  // return
  // useEffect(() => {
  //   // Check if this is a page refresh by looking at sessionStorage
  //   const isPageRefreshed = sessionStorage.getItem("pageRefreshed");

  //   if (isPageRefreshed) {
  //     dispatch(clearFilters()); // Clear the filters
  //     sessionStorage.removeItem("pageRefreshed"); // Reset the flag
  //   }

  //   // Set the flag when the page is loaded or refreshed
  //   window.onbeforeunload = () => {
  //     sessionStorage.setItem("pageRefreshed", "true");
  //   };

  //   return () => {
  //     window.onbeforeunload = null; // Clean up the event listener
  //   };
  // }, [dispatch]);

  // get applied filters----------------------------------------------------------------
  // const appliedFilters = useSelector((state) => state.filter.appliedFilters);
  // const hasUserApplied = useSelector((state) => state.filter.hasUserApplied);
  const { appliedFilters, hasUserApplied } = useSelector(
    (state) => state.filter,
  );

  // Reset page to 1 when filters are reset
  useEffect(() => {
    if (!appliedFilters) {
      setPage(1);
      setNewArrival([]);
    }
  }, [appliedFilters]);

  useEffect(() => {
    setPage(1);
  }, []);
  useEffect(() => {
    if (fromNewArrival) {
      setIsNewArrivalLoading(true);
    } else if (subCategoryId && subCategoryName) {
      setIsSubCategoryLoading(true);
    } else if (fromProductMetal) {
      setIsMetalLoading(true);
    }
  }, []);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setUserRole(result?.data?.[0]?.user_role_name);
        const booleanValue =
          result?.data?.[0]?.user_generic_data_value?.[0]
            ?.user_generic_data_boolean_value;

        // if (typeof booleanValue === "boolean") {
        //   SetIsWastageEnabled(booleanValue);
        // } else if (booleanValue === 0 || booleanValue === 1) {
        //   SetIsWastageEnabled(booleanValue === 1);
        // }
      }),
    );
  }, [dispatch]);

  // ===== from subcategory =======================================================================================================
  const fetchSubCategoryProducts = () => {
    setLoading(true);

    const params = {
      page: page,
      limit: 50,
      searchQuery: null,
      product_category_id: subCategoryId,
      manufacturer_id: manufactureId,
    };

    dispatch(
      getProductDetailsAPI(
        params,
        (result) => {
          const updateData = () => {
            setSubCategoryProducts((prev) => {
              // ✅ Prevent duplicate products before adding new ones
              const newData = Array.isArray(result?.data)
                ? result.data.filter(
                    (newProd) =>
                      !prev.some(
                        (prod) => prod.product_id === newProd.product_id,
                      ),
                  )
                : [];
              return [...prev, ...newData];
            });

            // if (result?.data?.length !== 0) {
            setProductsLength(
              result?.pagination?.total || result?.data?.length,
            );
            // }
            setIsSubCategoryLoading(false);
            setLoading(false);
          };

          if (page === 1) {
            updateData(); // No delay on first load
          } else {
            setTimeout(updateData, 1000); // 1s delay for subsequent pages
          }
        },
        params,
        location?.state?.manufacturerId,
      ),
    );
  };

  useEffect(() => {
    if (subCategoryId && subCategoryName) {
      const isSameScreen =
        appliedFilters?.appliedFilters?.screen_name ===
        location?.pathname?.split("/")[1];

      const isSameSubCategory =
        appliedFilters?.appliedFilters?.product_subcategory_id == subCategoryId;

      const shouldUseFilter =
        hasUserApplied && isSameScreen && isSameSubCategory;

      // setIsSubCategoryLoading(true);
      setSubCategory(subCategoryName);

      // ✅ Check for applied filters before fetching from API
      // if (
      //   appliedFilters &&
      //   appliedFilters?.appliedFilters?.screen_name ===
      //     `${location?.pathname?.split("/")[1]}` &&
      //   appliedFilters?.appliedFilters?.product_subcategory_id == subCategoryId
      // ) {
      if (shouldUseFilter) {
        if (!appliedFilters?.selectedFilters) {
          fetchSubCategoryProducts();
          return;
        }
        const selectedFilters = appliedFilters?.selectedFilters;

        // map carat to product_stamp_value
        let modifiedFilters = { ...selectedFilters }; // copy object
        if (modifiedFilters?.carat?.length) {
          const selectedCaratValues = modifiedFilters.carat
            .map((id) => {
              const match = caratOptions.find((opt) => opt.id === id);
              return match ? match.name : null;
            })
            .filter(Boolean);

          modifiedFilters.product_stamp_value = selectedCaratValues;
          delete modifiedFilters.carat;
        }
        setLoading(true);
        dispatch(
          getGlobalFilterAPI(
            modifiedFilters,
            (result) => {
              const updateData = () => {
                if (page === 1) {
                  setSubCategoryProducts(result?.data || []);
                } else {
                  setSubCategoryProducts((prev) => {
                    const newData = result?.data?.filter(
                      (newProd) =>
                        !prev.some(
                          (prod) => prod.product_id === newProd.product_id,
                        ),
                    );
                    return [...prev, ...newData];
                  });
                }

                // if (result?.data?.length !== 0) {
                setProductsLength(
                  result?.pagination?.total ||
                    result?.totalProductCount ||
                    result?.data?.length,
                );
                // }

                setIsSubCategoryLoading(false);
                setLoading(false);
              };

              if (page === 1) {
                updateData(); // No delay on first load
              } else {
                setTimeout(updateData, 1000); // 1s delay for next pages
              }
            },
            page,
            50,
          ),
        );
      } else {
        fetchSubCategoryProducts();
      }
    }
  }, [
    subCategoryId,
    subCategoryName,
    appliedFilters,
    page,
    manufactureId,
    hasUserApplied,
  ]);

  // ===== from metal =======================================================================================================
  const fetchMetalProducts = () => {
    // if (!hasMoreProducts) return; // Stop fetching if no more products

    setLoading(true);

    const params = {
      page: page,
      limit: 50,
      searchQuery: null,
    };

    dispatch(
      getProductsByMetalId(
        metalId,
        (result) => {
          const updateData = () => {
            setMetalProducts((prev) => {
              // ✅ Ensure result?.data is an array before filtering
              const newProducts = Array.isArray(result?.data)
                ? result.data
                : [];

              // ✅ Prevent duplicate products before adding new ones
              const newData = newProducts.filter(
                (newProd) =>
                  !prev.some((prod) => prod.product_id === newProd.product_id),
              );

              // Check if we've reached the total product count

              if (prev.length + newData.length >= result.totalProductCount) {
                setHasMoreProducts(false); // Stop fetching
              }

              return [...prev, ...newData];
            });

            // if (Array.isArray(result?.data) && result.data.length !== 0) {
            setProductsLength(
              result?.pagination?.total || result?.data?.length,
            );
            // }

            setIsMetalLoading(false);
            setLoading(false);
          };

          if (page === 1) {
            updateData(); // No delay on first load
          } else {
            setTimeout(updateData, 1000); // 1s delay for subsequent pages
          }
        },
        params,
      ),
    );
  };

  useEffect(() => {
    if (metalId && metalName) {
      // setIsMetalLoading(true);
      setProductMetalName(metalName);

      if (
        appliedFilters &&
        appliedFilters?.appliedFilters?.screen_name ===
          `${location?.pathname?.split("/")[1]}` &&
        metalName == appliedFilters?.appliedFilters?.product_metal_name
      ) {
        // setMetalProducts(appliedFilters?.appliedFilters?.data);
        // setProductsLength(appliedFilters?.appliedFilters?.totalProductCount);
        // setIsMetalLoading(false);
        const selectedFilters = appliedFilters?.selectedFilters;
        // map carat to product_stamp_value
        let modifiedFilters = { ...selectedFilters }; // copy object
        if (modifiedFilters?.carat?.length) {
          const selectedCaratValues = modifiedFilters.carat
            .map((id) => {
              const match = caratOptions.find((opt) => opt.id === id);
              return match ? match.name : null;
            })
            .filter(Boolean);

          modifiedFilters.product_stamp_value = selectedCaratValues;
          delete modifiedFilters.carat;
        }
        setLoading(true);
        dispatch(
          getGlobalFilterAPI(
            modifiedFilters,
            (result) => {
              const updateData = () => {
                if (page === 1) {
                  setMetalProducts(result?.data || []);
                } else {
                  setMetalProducts((prev) => {
                    const newData = result?.data?.filter(
                      (newProd) =>
                        !prev.some(
                          (prod) => prod.product_id === newProd.product_id,
                        ),
                    );
                    return [...prev, ...newData];
                  });
                }

                // if (result?.data?.length !== 0) {
                setProductsLength(
                  result?.pagination?.total ||
                    result?.totalProductCount ||
                    result?.data?.length,
                );
                // }

                setIsMetalLoading(false);
                setLoading(false);
              };

              if (page === 1) {
                updateData();
              } else {
                setTimeout(updateData, 1000);
              }
            },
            page,
            // 1,
            50, // Limit
          ),
        );
      } else {
        fetchMetalProducts();
      }
    }
  }, [dispatch, metalId, metalName, appliedFilters, page]);

  // ===== from top selling =======================================================================================================
  const fetchTopSellingProducts = () => {
    setLoading(true);
    const params = {
      page: page,
      limit: 50,
      searchQuery: null,
      view_all_top_selling_products: true,
    };

    dispatch(
      getTopSellingProductsAPI(params, (result) => {
        const updateData = () => {
          setTopSellingProducts((prev) => {
            if (result?.status) {
              const newData = result?.data?.filter(
                (newProd) =>
                  !prev.some((prod) => prod.product_id === newProd?.product_id),
              );
              return [...prev, ...newData];
            }
          });
          // setProductsLength(
          //   result?.totalProductCount || topSellingProducts?.length
          // );
          setProductsLength(result?.pagination?.total);
          setIsTopSellingLoading(false);
          setLoading(false);
        };

        if (page === 1) {
          updateData(); // No delay on first page
        } else {
          setTimeout(updateData, 1000); // Delay for scroll-like loading
        }
      }),
    );
  };
  useEffect(() => {
    if (fromTopSellingProduct) {
      const screenFromURL = location?.pathname?.split("/")[1];

      if (
        appliedFilters &&
        appliedFilters?.appliedFilters?.screen_name === screenFromURL
      ) {
        setLoading(true);
        const selectedFilters = appliedFilters?.selectedFilters;
        // map carat to product_stamp_value
        let modifiedFilters = { ...selectedFilters }; // copy object
        if (modifiedFilters?.carat?.length) {
          const selectedCaratValues = modifiedFilters.carat
            .map((id) => {
              const match = caratOptions.find((opt) => opt.id === id);
              return match ? match.name : null;
            })
            .filter(Boolean);

          modifiedFilters.product_stamp_value = selectedCaratValues;
          delete modifiedFilters.carat;
        }
        dispatch(
          getGlobalFilterAPI(
            modifiedFilters,
            (result) => {
              const updateData = () => {
                if (page === 1) {
                  setTopSellingProducts(result?.data || []);
                } else {
                  setTopSellingProducts((prev) => {
                    const newData = result?.data?.filter(
                      (newProd) =>
                        !prev.some(
                          (prod) => prod.product_id === newProd.product_id,
                        ),
                    );
                    return [...prev, ...newData];
                  });
                }
                setProductsLength(
                  result?.pagination?.total ||
                    result?.totalProductCount ||
                    result?.data?.length,
                );
                // setProductsLength(
                //   result?.totalProductCount || topSellingProducts?.length
                // );
                // }
                setIsTopSellingLoading(false);
                setLoading(false);
              };

              if (page === 1) {
                updateData();
              } else {
                setTimeout(updateData, 1000);
              }
            },
            page,
            50,
          ),
        );
      } else {
        fetchTopSellingProducts();
      }
    }
  }, [dispatch, fromTopSellingProduct, appliedFilters, page]);

  // ===== from new arrival =======================================================================================================
  const fetchNewArrivalProducts = () => {
    setLoading(true);
    const params = {
      page: page,
      limit: 50,
      searchQuery: null,
    };
    dispatch(
      getProductDetailsAPI(params, (result) => {
        const updateData = () => {
          setNewArrival((prev) => {
            // ✅ Remove duplicates
            const newData = result?.data?.filter(
              (newProd) =>
                !prev.some((prod) => prod.product_id === newProd.product_id),
            );
            return [...prev, ...newData];
          });
          // if (result?.data?.length !== 0) {
          // setProductsLength(
          //   result?.pagination?.total_records || result?.data?.length
          // );
          setProductsLength(result?.pagination?.total);
          // }
          // setProductsLength(result?.totalCount);
          setIsNewArrivalLoading(false);
          setLoading(false);
        };

        if (page === 1) {
          updateData(); // No delay on first mount
        } else {
          setTimeout(updateData, 1000); // 1s delay for subsequent pages
        }
      }),
    );
  };

  useEffect(() => {
    if (fromNewArrival) {
      // setIsNewArrivalLoading(true);
      const params = {
        page: page,
        limit: 50,
        searchQuery: null,
      };
      if (
        appliedFilters &&
        appliedFilters?.appliedFilters?.screen_name ===
          `${location?.pathname?.split("/")[1]}` //problem happens on this line
      ) {
        const selectedFilters = appliedFilters?.selectedFilters;

        // map carat to product_stamp_value
        let modifiedFilters = { ...selectedFilters }; // copy object
        if (modifiedFilters?.carat?.length) {
          const selectedCaratValues = modifiedFilters.carat
            .map((id) => {
              const match = caratOptions.find((opt) => opt.id === id);
              return match ? match.name : null;
            })
            .filter(Boolean);

          modifiedFilters.product_stamp_value = selectedCaratValues;
          delete modifiedFilters.carat;
        }
        setLoading(true);
        dispatch(
          getGlobalFilterAPI(
            modifiedFilters,
            (result) => {
              // setNewArrival((prev) => {
              //   // ✅ Remove duplicates
              //   const newData = result?.data?.filter(
              //     (newProd) =>
              //       !prev.some((prod) => prod.product_id === newProd.product_id)
              //   );
              //   return [...prev, ...newData];
              // });
              // setNewArrival(result?.data);
              // setProductsLength(result?.totalProductCount);
              // setIsNewArrivalLoading(false);

              const updateData = () => {
                if (page === 1) {
                  // ✅ Replace old data on first page
                  setNewArrival(result?.data || []);
                } else {
                  // ✅ Append new data and remove duplicates
                  setNewArrival((prev) => {
                    const newData = result?.data?.filter(
                      (newProd) =>
                        !prev.some(
                          (prod) => prod.product_id === newProd.product_id,
                        ),
                    );
                    return [...prev, ...newData];
                  });
                }
                // if (result?.data?.length !== 0) {
                setProductsLength(
                  result?.pagination?.total ||
                    result?.totalProductCount ||
                    result?.data?.length,
                );
                // }
                // setProductsLength(result?.totalCount);
                setIsNewArrivalLoading(false);
                setLoading(false);
              };

              if (page === 1) {
                updateData(); // No delay on first mount
              } else {
                setTimeout(updateData, 1000); // 1s delay for subsequent pages
              }
            },
            page,
            50,
          ),
        );
      } else {
        fetchNewArrivalProducts();
      }
    }
  }, [dispatch, fromNewArrival, appliedFilters, page]);

  const lastProductRef = (node) => {
    if (loading || !node) return;

    let totalLoaded = 0;
    if (fromProductMetal) totalLoaded = metalProducts?.length;
    else if (fromTopSellingProduct) totalLoaded = topSellingProducts?.length;
    else if (fromNewArrival) totalLoaded = newArrival?.length;
    else if (subCategory) totalLoaded = subCategoryProducts?.length;
    if (totalLoaded >= productsLength) return;
    // Initialize observer only once
    if (!observer.current) {
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setPage((prev) => prev + 1);
          }
        },
        { threshold: 0.8 },
      );
    }

    // Observe the last product only once
    observer.current.observe(node);
  };

  const onfetchFunctionTopSelling = useCallback(
    (pageNumber) => {
      const params = {
        page: pageNumber,
        limit: 50 * page,
        searchQuery: null,
        view_all_top_selling_products: true,
      };
      dispatch(
        getTopSellingProductsAPI(params, (result) => {
          if (appliedFilters?.status) {
            // Replace each filtered product with its latest version from fresh data
            const updatedData = appliedFilters?.data?.map((filteredItem) => {
              return (
                result?.data?.find(
                  (newItem) => newItem.product_id === filteredItem.product_id,
                ) || filteredItem // Use fresh data if available, else keep filtered item
              );
            });

            dispatch(
              applyFilters({
                status: true,
                total_filter_count: appliedFilters?.totalProductCount,
                data: updatedData,
                screen_name: location?.pathname?.split("/")[1],
              }),
            );
            setTopSellingProducts(updatedData);
            setProductsLength(appliedFilters?.totalProductCount);
          } else {
            setTopSellingProducts(result?.data || []);
            setProductsLength(result?.pagination?.total);
          }
        }),
      );
    },
    [[dispatch, appliedFilters]],
  );

  // const onfetchFunctionNewArrival = useCallback(() => {
  //   const params = {
  //     page: null,
  //     limit: null,
  //     searchQuery: null,
  //   };

  //   dispatch(
  //     getProductDetailsAPI(params, (result) => {
  //       if (appliedFilters?.status) {
  //         // Replace each filtered product with its latest version from fresh data
  //         const updatedData = appliedFilters?.data?.map((filteredItem) => {
  //           return (
  //             result?.data?.find(
  //               (newItem) => newItem.product_id === filteredItem.product_id
  //             ) || filteredItem // Use fresh data if available, else keep filtered item
  //           );
  //         });

  //         dispatch(
  //           applyFilters({
  //             status: true,
  //             total_filter_count: appliedFilters?.totalProductCount,
  //             data: updatedData,
  //             screen_name: location?.pathname?.split("/")[1],
  //           })
  //         );
  //         setNewArrival(updatedData);
  //         setProductsLength(appliedFilters?.totalProductCount);
  //       } else {
  //         setNewArrival(result?.data || []);
  //         setProductsLength(result?.totalCount);
  //       }
  //     })
  //   );
  // }, [dispatch, appliedFilters]);

  const onfetchFunctionNewArrival = useCallback(
    (pageNumber) => {
      const params = {
        page: pageNumber,
        limit: 50,
        searchQuery: null,
      };
      dispatch(
        getProductDetailsAPI(params, (result) => {
          if (appliedFilters?.appliedFilters?.status) {
            const updatedData = newArrival.map((existingProd) => {
              const updatedProd = result?.data?.find(
                (newItem) => newItem.product_id === existingProd.product_id,
              );
              return updatedProd ? updatedProd : existingProd;
            });
            // dispatch(
            //   applyFilters({
            //     status: true,
            //     total_filter_count: appliedFilters?.totalProductCount,
            //     data: updatedData,
            //     screen_name: location?.pathname?.split("/")[1],
            //   })
            // );
            dispatch(
              applyFilters({
                appliedFilters: {
                  status: true,
                  total_filter_count: appliedFilters?.totalProductCount,
                  data: updatedData,
                  screen_name: location?.pathname?.split("/")[1],
                },
                selectedFilters: appliedFilters?.selectedFilters,
              }),
            );
            setNewArrival(updatedData);
          } else {
            // ✅ Merge new data with existing list instead of replacing
            setNewArrival((prev) => {
              const updatedList = prev.map((existingProd) => {
                const updatedProd = result?.data?.find(
                  (newItem) => newItem.product_id === existingProd.product_id,
                );
                return updatedProd ? updatedProd : existingProd;
              });
              return updatedList;
            });
          }
        }),
      );
    },
    [dispatch, appliedFilters, newArrival],
  );

  const onfetchMetalFunction = useCallback(
    (pageNumber) => {
      const params = {
        page: pageNumber,
        limit: 50,
        searchQuery: null,
      };
      dispatch(
        getProductsByMetalId(
          metalId,
          (result) => {
            if (appliedFilters?.appliedFilters?.status) {
              const updatedData = metalProducts.map((existingProd) => {
                const updatedProd = result?.data?.find(
                  (newItem) => newItem.product_id === existingProd.product_id,
                );
                return updatedProd ? updatedProd : existingProd;
              });

              dispatch(
                applyFilters({
                  appliedFilters: {
                    status: true,
                    total_filter_count:
                      appliedFilters?.appliedFilters?.total_filter_count,
                    data: updatedData,
                    screen_name: location?.pathname?.split("/")[1],
                  },
                  selectedFilters: appliedFilters?.selectedFilters,
                }),
              );

              setMetalProducts(updatedData);
              // setProductsLength(
              //   appliedFilters?.appliedFilters?.total_filter_count
              // );
            } else {
              // setMetalProducts(result || []);
              // setProductsLength(result?.length);
              setMetalProducts((prev) => {
                const updatedList = prev.map((existingProd) => {
                  const updatedProd = result?.data?.find(
                    (newItem) => newItem.product_id === existingProd.product_id,
                  );
                  return updatedProd ? updatedProd : existingProd;
                });
                return updatedList;
              });
            }
          },
          params,
        ),
      );
    },
    [dispatch, appliedFilters],
  );

  const onfetchFunctionSubCatProducts = useCallback(
    (pageNumber) => {
      const params = {
        page: pageNumber,
        limit: 50,
        searchQuery: null,
        product_category_id: subCategoryId,
      };
      dispatch(
        getProductDetailsAPI(
          params,
          (result) => {
            if (appliedFilters?.appliedFilters?.status) {
              const updatedData = subCategoryProducts.map((existingProd) => {
                const updatedProd = result?.data?.find(
                  (newItem) => newItem.product_id === existingProd.product_id,
                );
                return updatedProd ? updatedProd : existingProd;
              });

              dispatch(
                applyFilters({
                  appliedFilters: {
                    status: true,
                    total_filter_count:
                      appliedFilters?.appliedFilters?.total_filter_count,
                    data: updatedData,
                    screen_name: location?.pathname?.split("/")[1],
                  },
                  selectedFilters: appliedFilters?.selectedFilters,
                }),
              );
              setSubCategoryProducts(updatedData);
              // setProductsLength(appliedFilters?.totalProductCount);
            } else {
              setSubCategoryProducts((prev) => {
                const updatedList = prev.map((existingProd) => {
                  const updatedProd = result?.data?.find(
                    (newItem) => newItem.product_id === existingProd.product_id,
                  );
                  return updatedProd ? updatedProd : existingProd;
                });
                return updatedList;
              });
              setProductsLength(result?.pagination?.total);
            }
          },
          params,
        ),
      );
    },
    [dispatch, appliedFilters],
  );

  const renderProductCards = () => {
    if (fromProductMetal && metalProducts?.length > 0) {
      return metalProducts?.map((prod, index) => (
        <div
          key={prod.product_id}
          ref={index === metalProducts.length - 1 ? lastProductRef : undefined}
        >
          <ProductCard
            key={index}
            image={`${prod?.product_image?.product_image_url}`}
            // title={prod.product_name || "No Title"}
            // title={
            //   prod?.product_subCategory_name
            //     ? `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
            //     : `${prod?.product_name}`
            // }
            title={
              prod?.product_subCategory_name && prod?.stamp_purity_value
                ? `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
                : `${prod?.product_name}`
            }
            netWeight={prod.product_net_weight || "N/A"}
            wastage={prod.product_wastage}
            fine={
              userRole.toLowerCase() === "retailer"
                ? prod.product_retailer_per_pcs_fine
                : userRole.toLowerCase() === "wholesaler"
                  ? prod.product_whole_seller_per_pcs_fine
                  : "N/A"
            }
            product={prod}
            isWishlist={prod.wishlist_id}
            flagCart={prod?.flag_cart}
            userRole={userRole}
            onGetWishlistProduct={onfetchMetalFunction}
            isWastageEnabled={isWastageEnabled}
            pageNumber={Math.floor(index / 50) + 1} // if 50 per page
          />
        </div>
      ));
    } else if (fromTopSellingProduct && topSellingProducts?.length > 0) {
      return topSellingProducts?.map((prod, index) => {
        return (
          <ProductCard
            key={index}
            image={`${prod?.product_image?.product_image_url}`}
            // title={prod.product_name || "No Title"}
            // title={
            //   prod?.product_subCategory_name
            //     ? `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
            //     : `${prod?.product_name}`
            // }
            title={
              prod?.product_subCategory_name && prod?.stamp_purity_value
                ? `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
                : `${prod?.product_name}`
            }
            netWeight={prod.product_net_weight || "N/A"}
            wastage={prod.product_wastage}
            fine={
              userRole.toLowerCase() === "retailer"
                ? prod.product_retailer_per_pcs_fine
                : userRole.toLowerCase() === "wholesaler"
                  ? prod.product_whole_seller_per_pcs_fine
                  : "N/A"
            }
            product={prod}
            isWishlist={prod.wishlist_id}
            flagCart={prod?.flag_cart}
            userRole={userRole}
            onGetWishlistProduct={onfetchFunctionTopSelling} // Fallback to an empty function
            isWastageEnabled={isWastageEnabled}
            pageNumber={Math.floor(index / 50) + 1} // if 50 per page
          />
        );
      });
    } else if (fromNewArrival && newArrival?.length > 0) {
      return newArrival?.map((prod, index) => (
        // <ProductCard
        //   ref={index === newArrival?.length - 1 ? lastProductRef : undefined}
        //   key={index}
        //   image={`${prod?.product_image?.product_image_url}`}
        //   title={prod?.product_name || "No Title"}
        //   netWeight={prod?.product_net_weight || "N/A"}
        //   wastage={prod?.product_wastage_of_retailer || "N/A"}
        //   fine={prod?.product_retailer_per_pcs_fine || "N/A"}
        //   product={prod}
        //   onGetWishlistProduct={onfetchFunctionNewArrival}
        //   isWishlist={prod?.isWishlist}
        //   cartId={prod?.cart_id}
        // />
        <div
          key={prod.id}
          ref={index === newArrival.length - 1 ? lastProductRef : undefined}
        >
          <ProductCard
            image={prod?.product_image?.product_image_url}
            // title={prod?.product_name || "No Title"}
            // title={
            //   prod?.product_subCategory_name
            //     ? `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
            //     : `${prod?.product_name}`
            // }
            title={
              prod?.product_subCategory_name && prod?.stamp_purity_value
                ? `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
                : `${prod?.product_name}`
            }
            netWeight={prod?.product_net_weight || "N/A"}
            wastage={prod.product_wastage}
            fine={
              userRole.toLowerCase() === "retailer"
                ? prod.product_retailer_per_pcs_fine
                : userRole.toLowerCase() === "wholesaler"
                  ? prod.product_whole_seller_per_pcs_fine
                  : "N/A"
            }
            product={prod}
            onGetWishlistProduct={onfetchFunctionNewArrival}
            isWishlist={prod?.wishlist_id}
            flagCart={prod?.flag_cart}
            userRole={userRole} // ✅ Passing userRole as a prop
            isWastageEnabled={isWastageEnabled} // ✅ Passing isWastageEnabled as a prop
            pageNumber={Math.floor(index / 50) + 1} // if 50 per page
          />
        </div>
      ));
    } else if (subCategory && subCategoryProducts?.length > 0) {
      return subCategoryProducts?.map((prod, index) => (
        <div
          key={prod.product_id}
          ref={
            index === subCategoryProducts.length - 1
              ? lastProductRef
              : undefined
          }
        >
          <ProductCard
            image={`${prod?.product_image?.product_image_url}`}
            // title={prod.product_name || "No Title"}
            // title={
            //   prod?.product_subCategory_name
            //     ? `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
            //     : `${prod?.product_name}`
            // }
            title={
              prod?.product_subCategory_name && prod?.stamp_purity_value
                ? `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
                : `${prod?.product_name}`
            }
            netWeight={prod.product_net_weight || "N/A"}
            wastage={prod.product_wastage}
            fine={
              userRole.toLowerCase() === "retailer"
                ? prod.product_retailer_per_pcs_fine
                : userRole.toLowerCase() === "wholesaler"
                  ? prod.product_whole_seller_per_pcs_fine
                  : "N/A"
            }
            product={prod}
            isWishlist={prod.wishlist_id}
            flagCart={prod?.flag_cart}
            userRole={userRole}
            onGetWishlistProduct={onfetchFunctionSubCatProducts}
            isWastageEnabled={isWastageEnabled}
            pageNumber={Math.floor(index / 50) + 1} // if 50 per page
          />
        </div>
      ));
    } else {
      return <p>No products available</p>;
    }
  };
  // Check if any of the individual loading states are true
  const isLoading =
    isSubCategoryLoading ||
    isMetalLoading ||
    isTopSellingLoading ||
    isNewArrivalLoading;
  return (
    <>
      <Helmet>
        <title>
          {subCategoryName ? `${subCategoryName} - Zabali` : "Zabali Products"}
        </title>

        <meta
          name="description"
          content={`Shop the best ${subCategoryName} at Your Brand. Browse products, compare prices, and find top-quality items.`}          
        />
        {/* <link
          rel="canonical"
          href={`https://www.yourwebsite.com/products/${subCategoryId}/${subCategoryName.toLowerCase().replace(/\s+/g, "-")}`}
        /> */}
      </Helmet>
      <Header />
      <div className="subCategoriesMainDiv">
        <>
          {(subCategory ||
            productMetalName ||
            fromTopSellingProduct ||
            fromNewArrival) && (
            <>
              <div className="upperContent">
                <h1>
                  {fromProductMetal     
                    ? productMetalName || "Product Metal Name"
                    : fromTopSellingProduct
                      ? "Top Selling Products"
                      : fromNewArrival
                        ? "New Arrivals"
                        : subCategory || "SubCategory Name"}
                </h1>
                <p>Shop our most popular products, loved by customers</p>
              </div>
              <div className="lowerContent">
                <div className="hrLine" />
                {isLoading ? (
                  <>
                    {/* <p>loading...</p> */}
                    <div className="loaderContainer">
                      <CustomLoader />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="menusDiv">
                      <div className="count-products-div">
                        <p>( {productsLength} product )</p>
                        {/* <p>( {productsLength ? productsLength : 0} product )</p> */}
                      </div>
                      {/* {productsLength > 0 && ( */}

                      <>
                        <MenuList
                          prodSubCategoryId={subCategoryId}
                          prodMetalId={metalId}
                          screen_name={location?.pathname?.split("/")[1]}
                          page={page}
                          selectedFilters={appliedFilters?.selectedFilters}
                          screen_name_from_filter={
                            appliedFilters?.appliedFilters?.screen_name
                          }
                          manufacturerId={manufactureId}
                          viewAllTopSellingProducts={fromTopSellingProduct}
                          // recordPerPage={recordPerPage}
                        />
                      </>
                      {/* )} */}

                      {/* <div className="filterDiv">
                  <FilterOptions />
                </div> */}
                    </div>

                    <div className="cardsMainDiv">{renderProductCards()}</div>
                    {loading && (
                      <div className="loaderContainer">
                        <CustomLoader />
                      </div>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </>
      </div>
      {isPopupVisible && (
        <OrderWeightInfoPopup
          onClose={handleClosePopup}
          refreshTrigger={cartChangeTrigger}
        />
      )}
      <Footer />
    </>
  );
};

export default ProductListsPage;
